// GENERATED by scripts/build_icons.mjs from react-icons 5.7.0: do not edit by hand.
import { GenIcon } from 'react-icons/lib'

export function FiStar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polygon","attr":{"points":"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"},"child":[]}]})(props);
};
